import { render, staticRenderFns } from "./ProductSpecsElementIndex.vue?vue&type=template&id=4d022a60"
import script from "./ProductSpecsElementIndex.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports